module.exports = __webpack_public_path__ + "static/media/freightspeed.88f46f76.png";